export const isEveryIndex = (arr, value) => (
  arr.every(v => v === value)
)

export const passwordValidator = password => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(password)

export default isEveryIndex



// WEBPACK FOOTER //
// ./src/utils/util-services.js